export const COMPANY_ENDPOINTS = {
  CREATE: "/company/create",
  LIST_PUBLIC: "/company/public",
  DETAIL: (companyId) => `/company/${companyId}`,
  UPDATE: (companyId) => `/company/${companyId}`,
};
